<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "relatorio-ven-check-in-out") {
            next({ name: "relatorio-ven-check-in-out-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "relatorio-ven-check-in-out") {
            this.$router.push({ name: "relatorio-ven-check-in-out-list" });
        }
    },
};
</script>